import React from 'react'
import PropTypes from 'prop-types'

const DimensionToggle = ({ selected, changeHandler }) => (
  <div className="cmwf--dimension-select-group">
    <label htmlFor="cmwf--dimension-select">Dimension</label>
    {' '}
    <select
      id="cmwf--dimension-select"
      className="select__small"
      onChange={e => changeHandler(e.target.value)}
      defaultValue={selected}
    >
      <option value="OVERALL">Overall Ranking</option>
      <option value="ACCESS">Access and Affordability</option>
      <option value="QUALITY">Prevention and Treatment</option>
      <option value="USE">Avoidable Hospital Use and Cost</option>
      <option value="LIVES">Healthy Lives</option>
      <option value="DISPARITY">Income Disparity</option>
    </select>
  </div>
)

DimensionToggle.propTypes = {
  selected: PropTypes.string.isRequired,
  changeHandler: PropTypes.func.isRequired,
}

export default DimensionToggle



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/dimension-toggle.jsx